module.exports = __webpack_public_path__ + "static/media/01_A1_-01.3bf499db.png";